export default __webpack_public_path__ + "static/media/hamburguer.38b9daaf.svg";